module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card mb-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Zarada")]), _vm._v(" "), _c('h6', {
    staticClass: "card-subtitle mb-2 text-muted"
  }, [_vm._v("Ukupan priliv")]), _vm._v(" "), _c('p', {
    staticClass: "card-text display-4"
  }, [_vm._v(_vm._s(_vm._f("decimal")(_vm.totalIncome)))])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Priliv u poslednjih 365 dana")]), _vm._v(" "), _c('p', {
    staticClass: "card-text display-4"
  }, [_vm._v(_vm._s(_vm._f("decimal")(_vm.rolling365Income)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Priliv po godini")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, _vm._l((_vm.incomePerYear), function(item) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('strong', [_vm._v(_vm._s(item.year))]), _vm._v(" " + _vm._s(_vm._f("decimal")(item.income)))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Dugovanja")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm._f("decimal")(_vm.totalDebt)))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "img-fluid w-25",
    attrs: {
      "src": require("../assets/logo2.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43537a12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 294
// module chunks = 1